define.alias("shared/helpers/are-equal", "media/helpers/are-equal");